/*
 * @Author: iCEA
 * @Date: 2020-11-04 17:39:27
 * @LastEditTime: 2020-12-01 00:52:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Listener.js
 */
export class Listener {
  /**
   * 监听器构造函数
   */
  constructor () {
    /**
     * @type {function[]} 执行函数列表
     */
    this.listeners = []
  }

  /**
   * 添加触发函数
   * @param {function} func 添加进执行列表的函数
   */
  add (func) {
    this.listeners.push(func)
  }

  /**
   * 从列表中移除对应触发函数
   * @param {function} func 删除的目标函数
   */
  remove (func) {
    for (let i = 0; i < this.listeners.length; ++i) {
      if (this.listeners[i] === func) {
        this.listeners.splice(i, 1)
      }
    }
  }

  /**
   * 执行列表中的函数
   * @param {object} e 执行函数时需要的参数
   */
  invoke (...e) {
    for (const f of this.listeners) {
      try {
        f(...e)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
